import { cleanString } from "../strings";

/**
 * This function is used to generate a bucket name for an organization.
 * @param orgId
 * @returns
 */
export function generateBucketName(orgId: string): string {
	return cleanString(orgId);
}
